import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface ConfirmationDialogData {
  title?: string;
  message: string;
  isHtml?: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule]
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string | ConfirmationDialogData,
    private sanitizer: DomSanitizer
  ) {}

  get message(): string {
    return typeof this.data === 'string' ? this.data : this.data.message;
  }

  get title(): string | undefined {
    return typeof this.data === 'string' ? undefined : this.data.title;
  }

  get isHtml(): boolean {
    return typeof this.data === 'string' ? false : (this.data.isHtml || false);
  }

  get safeHtmlMessage(): SafeHtml {
    if (this.isHtml) {
      return this.sanitizer.bypassSecurityTrustHtml(this.message);
    }
    return this.message;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
